import React from "react";

function SliderTooltip({ position, score }) {
  return (
    <span
      className="tooltip--span"
      style={{
        left: `${position}px`,
        zIndex: "-1",
        bottom: "28px",
        fontWeight: "bold",
        display: score > 9.9 ? "none" : "block",
      }}
    >
      {score}
    </span>
  );
}

export default SliderTooltip;
